@if ({
  action:'',
  }; as variables) {
  <div
    class="w-100"
    >
    <button
      class="px-2 me-2"
      kendoButton
      [fillMode]="!buttonsEnableState().enableDispatch ? 'outline' : 'solid'"
      rounded="large"
      themeColor="primary"
    [title]="
      _clientWO.bulkActionsDisabled()
        ? ('HOME.STREAM.DISABLED_TOOLTIP'
          | translate: { count: (_clientWO.loadedRowCount() | number) })
        : ('HOME_COMPONENTS.DISPATCH_RECALL.DISPATCH' | translate)
    "
      [disabled]="!buttonsEnableState().enableDispatch || _clientWO.bulkActionsDisabled()"
      (click)="showDispatchPopup = true; showDispatch()"
      >
      <fa-icon [icon]="faUserPlus" class="w-px-20 me-1"></fa-icon>
      {{ 'HOME_COMPONENTS.DISPATCH_RECALL.DISPATCH' | translate }}
    </button>
    <button
      class="px-2 me-2"
      kendoButton
      [fillMode]="!buttonsEnableState().enableRecall ? 'outline' : 'solid'"
      rounded="large"
      [themeColor]="'secondary'"
    [title]="
      _clientWO.bulkActionsDisabled()
        ? ('HOME.STREAM.DISABLED_TOOLTIP'
          | translate: { count: (_clientWO.loadedRowCount() | number) })
        : ('HOME_COMPONENTS.DISPATCH_RECALL.RECALL' | translate)
    "
      [disabled]="!buttonsEnableState().enableRecall || _clientWO.bulkActionsDisabled()"
      (click)="confirmRecall = true"
      >
      <fa-icon [icon]="faCircleArrowLeft" class="w-px-20 me-1"></fa-icon>
      {{ 'HOME_COMPONENTS.DISPATCH_RECALL.RECALL' | translate }}
    </button>
    @if (showDispatchPopup) {
      <kendo-dialog (close)="showDispatchPopup = false">
        <kendo-dialog-titlebar class="text-primary"
          >{{ 'HOME_COMPONENTS.DISPATCH_RECALL.DISPATCH' | translate }}
        </kendo-dialog-titlebar>
        <div class="p-3 dialog">
          <div class="mb-3 align-items-center d-flex">
            <kendo-label class="small-text attribute-label-medium">
              {{ 'HOME_COMPONENTS.DISPATCH_RECALL.TEAM' | translate }} :
            </kendo-label>
            <kendo-combobox
              [placeholder]="'HOME_COMPONENTS.DISPATCH_RECALL.SELECT_TEAM' | translate"
              class="attribute-dropdown-small small-text"
              [data]="territoryList"
              textField="territoryTitle"
              text="territoryTitle"
              valueField="id"
              #territory
              required
              [valuePrimitive]="true"
              (valueChange)="territoryValueChange($event)"
              >
            </kendo-combobox>
          </div>
          <div class="mb-3">
            <kendo-label class="small-text attribute-label-small"
              >{{ 'HOME_COMPONENTS.DISPATCH_RECALL.USERS_SELECTED' | translate }} :
            </kendo-label>
            <kendo-label class="attribute-dropdown-medium small-text">
              {{ selecteduser }}
            </kendo-label>
          </div>
          @if (userFilteredOut) {
            <div class="mb-3">
              <kendo-label class="small-text attribute-label-small text-primary">
                {{ 'HOME_COMPONENTS.DISPATCH_RECALL.USERS_FILTERED_OUT' | translate }}
              </kendo-label>
            </div>
          }
          <div class="grid-wrapper">
            <kendo-grid
              [data]="gridData"
              [style.maxHeight.px]="400"
              [filter]="gridStateGB.filter"
              [sortable]="true"
              [pageable]="false"
              [selectable]="{ checkboxOnly: true }"
              filterable="row"
              (dataStateChange)="onStateChange($event)"
              (selectionChange)="selectionChange($event)"
              [kendoGridSelectBy]="selectedCallback"
              [selectedKeys]="selectionOnGrid"
              >
              <kendo-grid-checkbox-column [width]="40">
                <ng-template
                  kendoGridCellTemplate
                  let-dataItem
                  let-rowIndex="rowIndex"
                  >
                  <input
                    style="margin-left: 5px"
                    type="checkbox"
                    kendoCheckBox
                    [kendoGridSelectionCheckbox]="rowIndex"
                    />
                </ng-template>
              </kendo-grid-checkbox-column>
              <ng-template kendoGridNoRecordsTemplate>
                <div>{{ 'HOME_COMPONENTS.DISPATCH_RECALL.NO_RECORDS_FOUND' | translate }}</div>
              </ng-template>
              <kendo-grid-column
                field="userName"
                [filterable]="true"
                [title]="'HOME_COMPONENTS.DISPATCH_RECALL.USER_NAME' | translate"
              ></kendo-grid-column>
              <kendo-grid-column
                field="count"
                [title]="'HOME_COMPONENTS.DISPATCH_RECALL.COUNT_WORK_ORDERS' | translate"
                [filterable]="false"
              ></kendo-grid-column>
            </kendo-grid>
            @if (loadingData) {
              <div class="k-loading-image"></div>
            }
          </div>
        </div>
        <kendo-dialog-actions [layout]="'end'">
          <button
            kendoButton
            look="outline"
            [themeColor]="'base'"
            [disabled]="disableSave()"
            (click)="showDispatchPopup = false"
            >
            <fa-icon [icon]="faTimes" class="w-px-20 me-1"></fa-icon>
            {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
          </button>
          <button
            kendoButton
            [themeColor]="'primary'"
            [disabled]="selecteduser == '' || disableSave()"
            (click)="onSave(); variables.action = 'dispatch'"
            >
            <span style="display: inline-block">
              <fa-icon [icon]="faCheck" class="w-px-20 me-1"></fa-icon>
              {{ 'HOME_COMPONENTS.DISPATCH_RECALL.SAVE_CLOSE' | translate }}
            </span>
          </button>
        </kendo-dialog-actions>
      </kendo-dialog>
    }
    @if (confirmRecall) {
      <kendo-dialog
        class="mb-4"
        (close)="confirmRecall = false"
        >
        <kendo-dialog-titlebar class="text-primary"
          >{{ 'HOME_COMPONENTS.COMMON.PLEASE_CONFIRM' | translate }}</kendo-dialog-titlebar
          >
          <div class="p-4">
            <span
              #dialogText
              id="dialogText"
              class="m-4 p-4 text-center"
        [innerHTML]="
          ('HOME_COMPONENTS.DISPATCH_RECALL.RECALL_CONFIRM' | translate)
        "
              >
            </span>
          </div>
          <kendo-dialog-actions [layout]="'end'">
            <button
              kendoButton
              [disabled]="disableSave()"
              look="outline"
              [themeColor]="'primary'"
              (click)="confirmRecall = false"
              >
              <fa-icon [icon]="faTimes" class="w-px-20 me-1"></fa-icon>
              {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
            </button>
            <button
              kendoButton
              [themeColor]="'primary'"
              [disabled]="disableSave()"
              (click)="variables.action = 'recall'; onRecallConfirm()"
              >
              <fa-icon [icon]="faCheck" class="w-px-20 me-1"></fa-icon>
              {{ 'HOME_COMPONENTS.COMMON.CONFIRM' | translate }}
            </button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
      @if (showValidationWarning) {
        <kendo-dialog [width]="520" (close)="onValidationCancel()">
          <kendo-dialog-titlebar class="title centerlabel">
            <fa-icon [icon]="faTriangleExclamation" class="text-warning me-2"></fa-icon>
            {{ 'HOME_COMPONENTS.DISPATCH_RECALL.VALIDATION_TITLE' | translate }}
          </kendo-dialog-titlebar>
          <div class="p-3">
            <p class="text-center">
              {{ 'HOME_COMPONENTS.DISPATCH_RECALL.VALIDATION_INTRO'
                 | translate: { count: totalBlocked() } }}
            </p>
            <ul>
              @for (group of validationGroups(); track group.validationName + group.message) {
                <li>
                  <strong>{{ group.message || group.title }}</strong>
                  &nbsp;—&nbsp;{{ 'HOME_COMPONENTS.DISPATCH_RECALL.WORK_ORDER_COUNT'
                                  | translate: { count: group.workOrderCount } }}
                </li>
              }
            </ul>
          </div>
          <kendo-dialog-actions [layout]="'end'">
            <button kendoButton look="outline" [themeColor]="'base'" (click)="onValidationCancel()">
              {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
            </button>
            <button kendoButton [themeColor]="'primary'" (click)="onValidationProceed()" class="ms-1">
              {{ 'HOME_COMPONENTS.DISPATCH_RECALL.PROCEED' | translate }}
            </button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
      @if (showOverride) {
        <kendo-dialog [height]="260" [width]="450" (close)="onOverrideCancel()">
          <kendo-dialog-titlebar class="title centerlabel">
            {{ 'HOME_COMPONENTS.DISPATCH_RECALL.OVERRIDE_TITLE' | translate }}
          </kendo-dialog-titlebar>
          <div class="p-3">
            <div class="text-center mb-2">{{ 'HOME_COMPONENTS.DISPATCH_RECALL.TYPE_OVERRIDE' | translate }}</div>
            <div class="text-center mb-3 mt-3">
              <kendo-textbox [(ngModel)]="overrideText"></kendo-textbox>
            </div>
          </div>
          <kendo-dialog-actions [layout]="'end'">
            <button kendoButton look="outline" [themeColor]="'base'" (click)="onOverrideCancel()">
              {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
            </button>
            <button kendoButton [themeColor]="'primary'" class="ms-1"
              [disabled]="overrideText !== 'OVERRIDE'" (click)="onOverrideConfirm()">
              {{ 'HOME_COMPONENTS.DISPATCH_RECALL.CONTINUE' | translate }}
            </button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
      @if (status != null) {
        <kendo-dialog class="mb-4" (close)="status = null">
          <div class="p-3">
            @if (status) {
              <img src="../../../assets/person_finish.svg" />
            }
            @if (!status) {
              <img src="../../../assets/person_falling.svg" />
            }
            <span
              #dialogText
              id="dialogText"
              class="m-4 p-4 text-center"
        [innerHTML]="
          this.status
            ? ('HOME_COMPONENTS.DISPATCH_RECALL.ACTION_DONE_SUCCESS' | translate : { action: ('HOME_COMPONENTS.DISPATCH_RECALL.ACTION_' + (variables.action || '').toUpperCase()) | translate })
            : ('HOME_COMPONENTS.DISPATCH_RECALL.ACTION_FAILED' | translate : { action: ('HOME_COMPONENTS.DISPATCH_RECALL.ACTION_' + (variables.action || '').toUpperCase()) | translate })
        "
              >
            </span>
          </div>
          <kendo-dialog-actions [layout]="'end'">
            <button kendoButton (click)="status = null" [themeColor]="'primary'">{{ 'HOME_COMPONENTS.COMMON.OK' | translate }}</button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
    </div>
  }
